import { type Article, type ArticleFromQueryArray } from "@lib/types";

export function formatDate(dateString?: string): string {
  if (!dateString) return "";
  try {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch {
    return "";
  }
}

export function getArticleUrl(article: Article | ArticleFromQueryArray): string {
  if (!article?.slug || !article?._type) return "#";
  return `/${article._type}/${article.slug}`;
}

export function capitalizeFirst(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
